import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

export const URL_ADMIN_PARTNER_CONFIGURATIONS = `${URL_APP_ADMIN}/partner-configurations`
export const URL_ADMIN_PARTNER_CONFIGURATIONS_APPROVAL_REQUEST = `${URL_ADMIN_PARTNER_CONFIGURATIONS}/approval-request/:approvalRequestId`

export type SharedPartnerConfigurationsRouteSet =
  DashRouteType<'app-admin-partner-configurations-approval-request'>

export const SharedPartnerConfigurationsRoutes: {
  [Key in SharedPartnerConfigurationsRouteSet['identifier']]: string
} = {
  'app-admin-partner-configurations-approval-request':
    URL_ADMIN_PARTNER_CONFIGURATIONS_APPROVAL_REQUEST,
}

export type DomainRouteName = keyof typeof SharedPartnerConfigurationsRoutes
